// extracted by mini-css-extract-plugin
export default {"layout":"ar4aOK","layoutContent":"br4aOK"};